export default class EventController {
    static dispatch(key: string) {
        window.dispatchEvent(new Event(key))
    }
}